import { Flex } from '@chakra-ui/react';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useAuth } from 'react-oidc-context';

import Loader from '@/components/Loader';
import Sidebar from '@/components/common/Sidebar';
import { Toaster } from '@/components/ui/toaster';

export const Route = createFileRoute('/_layout')({
  component: Layout,
});

function Layout() {
  const auth = useAuth();

  return (
    <Flex maxW="large" h="auto" position="relative">
      <Sidebar />
      {auth.isLoading ? <Loader /> : <Outlet />}
      <Toaster />
    </Flex>
  );
}
